<h1 mat-dialog-title style="text-align: center">Information</h1>
<div mat-dialog-content>
  <p class="{{data.class}} text-center">{{data.message}}</p>
</div>
<div mat-dialog-actions style="justify-content:center">
  <button type="button" class="btn btn-custom_primary ml-2 mr-2 deleteButton" mat-dialog-close
    (click)="confirm()">Ok</button>
</div>